import { useEffect } from "react"
import Axios from "axios"
import { useImmerReducer } from "use-immer"

export const useTvShowFetch = () => {
  const initialState = {
    tv: [
      {
        genre_ids: [],
        original_name: "",
        origin_country: [],
        poster_path: "",
        vote_average: "",
        id: "",
        overview: "",
        vote_count: 1064,
        name: "",
        original_language: "",
        backdrop_path: "",
        first_air_date: "",
        popularity: "",
        media_type: "",
      },
    ],
    isMovieFetching: "",
    isTvFetching: "",
    page: 1,
    loadMoreRequestCount: 0,
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "loadTvShow":
        draft.tv = action.data
        return
      case "loadMoreTvShows":
        draft.tv = draft.tv.concat(action.data)
        return
      case "fetchingRequestStart":
        draft.isMovieFetching = action.value
        return
      case "loadMore":
        draft.page = draft.page + 1
        draft.loadMoreRequestCount = draft.loadMoreRequestCount + 1
        return
      default:
        console.log("our")
    }
  }

  const [state, dispatchTv] = useImmerReducer(ourReducer, initialState)

  const fetchTvShows = async function (ourRuqest) {
    let endpoint = state.page > 0 ? `https://api.themoviedb.org/3/tv/popular?api_key=7fbee08a98f375581b229c2f62eb585e&language=en-US&page=${state.page}` : "https://api.themoviedb.org/3/movie/tv?api_key=7fbee08a98f375581b229c2f62eb585e&language=en-US&page=1"
    try {
      let response = await Axios.get(endpoint, { cancelToken: ourRuqest.token })
      if (state.page > 1) {
        dispatchTv({ type: "loadMoreTvShows", data: response.data.results })
      } else {
        dispatchTv({ type: "loadTvShow", data: response.data.results })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const ourRuqest = Axios.CancelToken.source()
    fetchTvShows(ourReducer)
    return () => {
      ourRuqest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.page])

  let tv = state.tv

  return [tv, dispatchTv]
}
